import { useCallback, useEffect, useState } from 'react';
import useAxios from './useAxios';
import Constants from '../Constants';

// Derives the display-ready value increase from a case-wide or per-plaintiff estimate slice.
const buildIncreaseDisplay = (source) => {
    const percentageIncrease = source?.percentageIncrease ?? 0;
    const hasEstimate = Boolean(source?.hasEstimate) && percentageIncrease > 0;
    return { hasEstimate, formattedIncrease: `${Math.round(percentageIncrease)}%` };
};

const useLifecarePlanEstimate = ({ caseId }) => {
    const [estimate, setEstimate] = useState(null);
    const { getData, isLoading } = useAxios();

    useEffect(() => {
        if (!caseId) return;
        const fetchEstimate = async () => {
            try {
                const response = await getData(`${Constants.ApiUrl.caseSummary.getLifecarePlanValue}/${caseId}/lifecare-plan-value`);
                if (response?.success) {
                    setEstimate(response.data);
                }
            } catch (error) {
                console.error('Error fetching life care plan estimate:', error);
            }
        };
        fetchEstimate();
    }, [caseId, getData]);

    const getIncreaseForClient = useCallback((clientId) => {
        const clientEstimate = estimate?.byClient?.find((entry) => entry.clientId === clientId);
        return buildIncreaseDisplay(clientEstimate || estimate);
    }, [estimate]);

    return { estimate, getIncreaseForClient, isLoading };
};

export default useLifecarePlanEstimate;
